import React, { createContext, useContext, ReactNode, useState } from 'react';
import { Winning } from '../types/prize.types';

interface PrizeExpansionContextType {
    expandedPrizeId: string | null;
    setExpandedPrizeId: (prizeId: string | null) => void;
    sortedPrizes: Winning[];
    setSortedPrizes: (prizes: Winning[]) => void;
}

const PrizeExpansionContext = createContext<PrizeExpansionContextType | undefined>(undefined);

export const PrizeExpansionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [expandedPrizeId, setExpandedPrizeId] = useState<string | null>(null);
    const [sortedPrizes, setSortedPrizes] = useState<Winning[]>([]);

    return (
        <PrizeExpansionContext.Provider
            value={{
                expandedPrizeId,
                setExpandedPrizeId,
                sortedPrizes,
                setSortedPrizes
            }}
        >
            {children}
        </PrizeExpansionContext.Provider>
    );
};

export const usePrizeExpansion = (): PrizeExpansionContextType => {
    const context = useContext(PrizeExpansionContext);
    if (!context) {
        throw new Error('usePrizeExpansion must be used within a PrizeExpansionProvider');
    }
    return context;
};
